import editorConfig from './editor-config.js'

// config relevant to pixi and creation of a canvas
var pixiConfig = {
  backgroundColor: 0x000000,
  width: editorConfig.width,
  height: editorConfig.height
}

export default pixiConfig
